import { render, staticRenderFns } from "./InternalPromosExpired.vue?vue&type=template&id=3dc960ae"
import script from "./InternalPromosExpired.vue?vue&type=script&lang=js"
export * from "./InternalPromosExpired.vue?vue&type=script&lang=js"
import style0 from "./InternalPromosExpired.vue?vue&type=style&index=0&id=3dc960ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports